export default "__VITE_ASSET__CPGH5h2O__"